module.exports = __webpack_public_path__ + "img/tax02.d206d4cb.png";